/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/ViewPage/index.tsx
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

/* eslint-disable react/require-default-props */
import Icon, { SearchOutlined } from '@ant-design/icons'
import { FontAwesomeIcon as FaIcon } from '@fortawesome/react-fontawesome'
import { Button, Card, Col, Input, Layout, Row, Space } from 'antd'
import React, { ChangeEvent, ReactNode, useEffect, useState } from 'react'
import { useAccess } from '../../../../../../../context/useAccess'
import { ItensPerUserLogged } from '../../services/login/permissaoUsuarioLoado'
import secureLocalStorage from 'react-secure-storage'

export interface TypesViewPage {
  newHide?: boolean
  disableNew?: boolean
  title: string
  search?: boolean
  btnClick?: () => void
  inputChange?: (data: ChangeEvent) => void
  btnsExta?: ReactNode
  content?: ReactNode
  rotina?: number
  onPermission?: (data: ItensPerUserLogged) => void
  hidden?: boolean
  rotinaExtra?: number[]
  onPermissionsExtra?: (data: ItensPerUserLogged[]) => void
  nameButton?: string
  hiddeTitle?: boolean;
  cardBodyStyle?: React.CSSProperties;
  cardMainStyle?: React.CSSProperties;
  justifyContent?: 'center' | 'flex-start' | 'flex-end' | 'space-between'
}

const { Content } = Layout

const ViewPage: React.FC<TypesViewPage> = (props) => {
  const { permission } = useAccess()

  const {
    newHide = false,
    disableNew = false,
    search = false,
    title,
    btnClick,
    inputChange,
    children,
    btnsExta = null,
    rotina = 0,
    content = <></>,
    onPermission,
    hidden = false,
    rotinaExtra = [],
    onPermissionsExtra,
    nameButton = 'Novo',
    hiddeTitle = false,
    cardBodyStyle,
    cardMainStyle,
  } = props

  const [dataPermissions, setDataPermissions] = useState<ItensPerUserLogged>({
    acesso: 0,
    alteracao: 0,
    cod: 0,
    cod_perfil: 0,
    cod_rotina: 0,
    exclusao: 0,
    inclusao: 0,
    perfil_nome: '',
    rotina_nome: '',
  })

  useEffect(() => {
    let dados

    if (rotina > 0 && permission) {
      dados = permission.find((item) => item.cod_rotina === rotina)
      setDataPermissions(
        dados || {
          acesso: 0,
          alteracao: 0,
          cod: 0,
          cod_perfil: 0,
          cod_rotina: 0,
          exclusao: 0,
          inclusao: 0,
          perfil_nome: '',
          rotina_nome: '',
        }
      )
      onPermission?.(dados)

      if (rotinaExtra.length > 0) {
        const rotinas = rotinaExtra.map((cod) => {
          return permission.find((item) => item.cod_rotina === cod)
        })
        onPermissionsExtra?.(rotinas)
      }
    }
  }, [])
  return (
    <Content hidden={hidden}>
      <Col span={24} style={{ overflow: 'hidden', height: '89vh' }}>
        {!hiddeTitle && (
          <Card
            size='small'
            title={title}
            bodyStyle={
              newHide && !btnsExta
                ? { display: 'none', overflow: 'auto', height: '100%' }
                : { display: 'block', overflow: 'auto', height: '100%' }
            }
          >
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Space style={{ width: '100%' }}>
                  {!newHide ? (
                    <Button
                      disabled={disableNew}
                      hidden={
                        dataPermissions?.inclusao === 0 &&
                        secureLocalStorage.getItem('tipo-acesso') !== 'admin'
                      }
                      icon={<Icon component={() => <FaIcon icon='plus' />} />}
                      onClick={() => btnClick?.()}
                      type='primary'
                    >
                      {nameButton}
                    </Button>
                  ) : null}
                  {btnsExta}
                  {search ? (
                    <Input
                      placeholder='Pesquisar'
                      style={{ minWidth: '150px' }}
                      onChange={(data) => inputChange(data)}
                      allowClear
                      prefix={<SearchOutlined />}
                    />
                  ) : null}
                </Space>
              </Col>
            </Row>
          </Card>
        )}

        <Card
          style={{
            overflow: 'hidden',
            height: newHide === true && btnsExta === null ? '85vh' : '83vh',
            ...cardMainStyle
          }}
          bodyStyle={cardBodyStyle}
        >
          {children}
        </Card>
        {content}
      </Col>
    </Content>
  )
}

export default ViewPage